// src/hooks/useDataVisibilityPermissions.ts
import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { DATA_VISIBILITY_PERMISSIONS } from '../constants/permissions.constants';

const DV = DATA_VISIBILITY_PERMISSIONS;

/**
 * Flags globales de Visibilidad de datos (detalle pieza / producto).
 * Opción A = UI-only: hide fields in the client; APIs still return the values.
 */
export const useDataVisibilityPermissions = () => {
  const canShowCostUnitPrice = usePermission(DV.COST_UNIT_PRICE);
  const canShowCostPerGram = usePermission(DV.COST_PER_GRAM);
  const canShowSalePrice = usePermission(DV.SALE_PRICE);
  const canShowSalePricePerGram = usePermission(DV.SALE_PRICE_PER_GRAM);
  const canShowFinalPrice = usePermission(DV.FINAL_PRICE);
  const canShowProfit = usePermission(DV.PROFIT);
  const canShowMargin = usePermission(DV.MARGIN);
  const canShowSupplierName = usePermission(DV.SUPPLIER_NAME);
  const canShowSupplierStatus = usePermission(DV.SUPPLIER_STATUS);
  const canShowSupplierFilter = usePermission(DV.FILTER_SUPPLIER);
  const canShowSupplierCodeFilter = usePermission(DV.FILTER_SUPPLIER_CODE);

  return useMemo(
    () => ({
      canShowCostUnitPrice,
      canShowCostPerGram,
      canShowSalePrice,
      canShowSalePricePerGram,
      canShowFinalPrice,
      canShowProfit,
      canShowMargin,
      canShowSupplierName,
      canShowSupplierStatus,
      hasAnyPriceField:
        canShowCostUnitPrice ||
        canShowCostPerGram ||
        canShowSalePrice ||
        canShowSalePricePerGram ||
        canShowFinalPrice ||
        canShowProfit ||
        canShowMargin,
      hasAnySupplierField: canShowSupplierName || canShowSupplierStatus,
      canShowSupplierFilter,
      canShowSupplierCodeFilter,
    }),
    [
      canShowCostUnitPrice,
      canShowCostPerGram,
      canShowSalePrice,
      canShowSalePricePerGram,
      canShowFinalPrice,
      canShowProfit,
      canShowMargin,
      canShowSupplierName,
      canShowSupplierStatus,
      canShowSupplierFilter,
      canShowSupplierCodeFilter,
    ],
  );
};
